import { theme } from "./theme";
import { useMediaQuery } from "@mui/material";

export default function useBreakpoints(bp) {
    return useMediaQuery(theme.breakpoints.up(bp));
}
